<template>
  <PreloaderComponent v-show="!isLoaded" />
  <div v-show="isLoaded" class="tsl">
    <h1 class="tsl__subheader">Заявление на предоставление сведений/справки об уплаченных взносах</h1>
    <div class="tsl__infoWrapper">
      <h2>Данные заявителя:</h2>
    </div>
    <div class="tsl__infoWrapper">
      <div class="tsl__infoWrapper-row">
        <div class="tsl__infoWrapper-input">
          <label>ФИО</label>
          <MakcInputComponent
            type="text"
            placeholder="ФИО"
            :class="v$.data.full_name.$errors.length > 0 ? 'field-error' : ''"
            v-model="v$.data.full_name.$model"
            :isDisabled="data.full_name.length > 0"
          />
        </div>
        <div class="tsl__infoWrapper-input">
          <label>Дата рождения</label>
          <input
            type="date"
            class="tsl__dateInput"
            :disabled="data.birth_date.length > 0"
            :class="v$.data.birth_date.$errors.length > 0 ? 'field-error' : ''"
            v-model="v$.data.birth_date.$model"
          >
        </div>
        <div class="tsl__infoWrapper-input">
          <label>Телефон</label>
          <div class="makc-input-wrapper" :class="v$.data.phone.$errors.length > 0 ? 'field-error' : ''">
            <input
              v-model="v$.data.phone.$model"
              type="text"
              placeholder=""
              v-mask="{
                      mask: '+7 (F##) ###-##-##',
                      tokens: {
                        F: {
                          pattern: /(?!8)\d/,
                        },
                        '#': { pattern: /\d/ },
                      },
                    }"
            />
          </div>
          <ValidationErrorComponent :errors="v$.data.phone.$errors" />
        </div>
        <div class="tsl__infoWrapper-input">
          <label>Электронная почта</label>
          <MakcInputComponent
            type="text"
            placeholder="Электронная почта"
            v-model="data.email"
          />
        </div>
      </div>
      <div class="tsl__infoWrapper-row tsl__infoWrapper-row_mt">
        <div class="tsl__infoWrapper-input">
          <label>Серия документа</label>
          <MakcInputComponent
            type="text"
            placeholder="Серия"
            :class="v$.data.doc_serial.$errors.length > 0 ? 'field-error' : ''"
            :isDisabled="data.doc_serial.length > 0"
            v-model="v$.data.doc_serial.$model"
          />
          <ValidationErrorComponent :errors="v$.data.doc_serial.$errors" />
        </div>
        <div class="tsl__infoWrapper-input">
          <label>Номер документа</label>
          <MakcInputComponent
            type="text"
            placeholder="Номер"
            :class="v$.data.doc_number.$errors.length > 0 ? 'field-error' : ''"
            :isDisabled="data.doc_number.length > 0"
            v-model="v$.data.doc_number.$model"
          />
          <ValidationErrorComponent :errors="v$.data.doc_number.$errors" />
        </div>
        <div class="tsl__infoWrapper-input tsl__infoWrapper-input_2">
          <label>Кем и когда выдан документ</label>
          <MakcInputComponent
            type="text"
            placeholder="Кем и когда выдан"
            :class="v$.data.doc_auth.$errors.length > 0 ? 'field-error' : ''"
            :isDisabled="data.doc_auth.length > 0"
            v-model="v$.data.doc_auth.$model"
          />
          <ValidationErrorComponent :errors="v$.data.doc_auth.$errors" />
        </div>
      </div>
    </div>
    <div class="tsl__infoWrapper">
      <h2>Прошу предоставить справку/отправить сведения об уплаченных взносах по договору:</h2>
    </div>
    <div class="tsl__infoWrapper">
      <div class="tsl__infoWrapper-row">
        <div class="tsl__infoWrapper-input">
          <label>Номер договора</label>
          <MakcInputComponent
            type="text"
            placeholder=""
            :isDisabled="data.policy_number.length > 0"
            :class="v$.data.policy_number.$errors.length > 0 ? 'field-error' : ''"
            v-model="v$.data.policy_number.$model"
          />
          <ValidationErrorComponent :errors="v$.data.policy_number.$errors" />
        </div>
        <div class="tsl__infoWrapper-input">
          <label>Дата договора</label>
          <input
            type="date"
            class="tsl__dateInput"
            :disabled="data.policy_date.length > 0"
            :class="v$.data.policy_date.$errors.length > 0 ? 'field-error' : ''"
            v-model="v$.data.policy_date.$model"
          >
          <ValidationErrorComponent :errors="v$.data.policy_date.$errors" />
        </div>
      </div>
      <div class="tsl__infoWrapper-row tsl__infoWrapper-row_mt2">
        <div class="tsl__infoWrapper-input tsl__infoWrapper-input_width">
          <label>За период (укажите все периоды)</label>
          <MakcInputComponent
            type="text"
            placeholder="Кем и когда выдан"
            :class="v$.period.$errors.length > 0 ? 'field-error' : ''"
            v-model="v$.period.$model"
          />
          <ValidationErrorComponent :errors="v$.period.$errors" />
        </div>
      </div>
    </div>
    <div class="mtK mt-10">
      <MakcButtonComponent
        :disabled="sending"
        @click="sendData"
        class="primary">
        Отправить заявление
      </MakcButtonComponent>
      <MakcButtonComponent :disabled="sending" @click="cancel_modal = true">
        Отменить
      </MakcButtonComponent>
    </div>
  </div>

  <MakcDialogComponent
    :title="'Подача заявления отменена'"
    :icon="'success'"
    :width="'815px'"
    btn_text="OK"
    v-model:show="cancel_modal"
    @close_modal="cancel"
  />
  <MakcDialogComponent
    :title="'Заявление успешно подано!'"
    :text="'Отслеживать статус заявления можно в разделе “Поданные заявления”'"
    :icon="'success'"
    :width="'607px'"
    btn_text="OK"
    @close_modal="success_modal"
    v-model:show="success"
  />
</template>

<script>
import { mask } from "vue-the-mask";
import { useVuelidate } from "@vuelidate/core";
import { required, maxLength, minLength } from "@vuelidate/validators";
import ValidationErrorComponent from "@/profile/components/ValidationErrorComponent.vue";
import MakcInputComponent from "@/profile/components/UI/MakcInputComponent";
import MakcButtonComponent from "@/profile/components/UI/MakcButtonComponent";
import MakcDialogComponent from "@/profile/components/UI/MakcDialogComponent";
import PreloaderComponent from "@/profile/components/PreloaderComponent.vue";

export default {
  components: {
    ValidationErrorComponent,
    MakcInputComponent,
    MakcButtonComponent,
    MakcDialogComponent,
    PreloaderComponent
  },
  props: {
    id: {
      type: String
    }
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data: () => {
    return {
      data: {
        first_name: " ",
        last_name: " ",
        middle_name: " ",
        full_name: "",
        birth_date: "",
        phone: "",
        email: "",
        doc_type: "1",
        doc_number: "",
        doc_serial: "",
        doc_auth: "",
        policy_date: "",
        policy_number: ""
      },
      period: "",
      isLoaded: false,
      cancel_modal: false,
      success: false,
      errors: [],
      contract_data: {},
      sending: false,
    };
  },
  validations() {
    return {
      data: {
        full_name: { required },
        birth_date: { required },
        doc_serial: { required },
        doc_number: { required },
        doc_auth: { required, maxLength: maxLength(200) },
        phone: { required, minLength: minLength(18) },
        policy_number: { required },
        policy_date: { required },
      },
      period: { required }
    };
  },
  directives: { mask },
  created() {
    // загружаем данные, когда представление создано, данные реактивно отслеживаются
    this.fetchData();
  },
  computed: {
    dateNow() {
      return new Date().toISOString().slice(0, 10);
    },
    formattedText() {
      return `Договор страхования обеспечит вам уверенность и поддержку
в непредвиденной жизненной ситуации.

Благодарим за выбор страховой компании ООО «МАКС-Жизнь».`.replace(/\n/g, "<br>");
    },
  },
  watch: {
    // при изменениях маршрута запрашиваем данные снова
    $route: "fetchData"
  },
  methods: {
    cancel() {
      this.$router.push({ name: "contract", params: { id: this.id } });
    },
    success_modal() {
      this.$router.push({ name: "contract", params: { id: this.id } });
    },
    async sendData() {
      this.errors = [];
      let d = new Date();
      let cur_arr = d.toISOString().split('T');
      let unique_code = String(this.id) + String(d.getTime());
      // console.log(unique_code);
      if (this.v$.$invalid) {
        this.v$.$touch();
        alert("Для отправки заявления, пожалуйста, заполните все обязательные поля");
        this.errors.push("Для отправки заявления, пожалуйста, заполните все обязательные поля");
        return;
      } else {
        let params;
          let tmp_phon = this.data.phone.replace(/[^0-9]/g, '').substring(1);
          console.log(tmp_phon);
          let tmp_phone = this.data.phone.replace("(", "");
          tmp_phone = tmp_phone.replace(")", "");
          tmp_phone = tmp_phone.replace("-", "");
          tmp_phone = tmp_phone.replace("-", "");
          tmp_phone = tmp_phone.replace("+", "");
          tmp_phone = tmp_phone.replace(" ", "");
          tmp_phone = tmp_phone.replace(" ", "");
          tmp_phone = tmp_phone.substring(1);

          if (tmp_phone === "0000000000") {
            alert("Введите корректный номер телефона");
            return;
          }

          this.sending = true;
          params = {
            action: "send-statement",
            object: "cpa",
            sent_data: {
              contract_id: this.id,
              police: this.data.policy_number,
              police_date: this.data.policy_date,
              date_signin: cur_arr[0],
              unique_code: unique_code,
              type: 'tax_certificate',
              statement_data: {
                full_name: this.data.full_name,
                birth_date: this.data.birth_date,
                phone: this.data.phone.replace(/[^0-9]/g, '').substring(1),
                email: this.data.email,
                doc_number: this.data.doc_number,
                doc_serial: this.data.doc_serial,
                doc_auth: this.data.doc_auth,
                period: this.period,
                type: 'e_statement',
              },
            },
            token: this.$myApp.token.get(),
          };
        this.contract_data = params;

        const api = await this.$api2.get(params);
        if (api.success) {
          if (api.data.result) {
            this.success = true;
            this.sending = false;
          } else {
            console.log(api);
            alert('Что то пошло не так, повторите отправку позже')
          }
        }
        if (api.error) {
          alert('Что то пошло не так, повторите отправку позже')
          console.log(api);
        }



      }
    },
    async fetchData() {
      let contract = this.$myApp.contract.get();
      if (contract.agreement_id === undefined) {
        await this.getIds();
        contract = this.$myApp.contract.get();
      }
      const api = await this.$api2.get({
        action: "get-taxcertificate-contract",
        object: "cpa",
        agreement_id: contract.agreement_id,
        contract_id: contract.contract_id,
        version_id: contract.version_id,
        cover_id: contract.cover_id,
        document_id: contract.document_id,
        token: this.$myApp.token.get()
      });
      if (api.error) {
        this.errors = [];
        this.errors.push(api.errors);
      }
      if (api.success) {
        this.data = api.data.contract;
        this.contract_data = api.data.contract;
        this.isLoaded = true;
      }
    },
    async getIds() {
      const api = await this.$api2.get({
        action: "get-ids-by-agreement",
        object: "cpa",
        agreement_id: this.id,
        token: this.$myApp.token.get()
      });
      if (api.success) {
        this.$myApp.contract.set(api.data.contract);
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.field-error {
  border: 2px solid red !important;
  outline: 2px solid red !important;
}

.makc-input-wrapper {
  position: relative;

  input {
    width: 100%;
    padding: 7px 10px;
    outline: none;
    border: 1px solid #b8b8b8;
  }

  input:disabled {
    background-color: #ecebeb;
  }

}
</style>